module.exports = __webpack_public_path__ + "static/media/LWT.2868faac.jpg";